<template>
  <div class="holiday-closure">
    <table class="holiday-table">
      <thead>
        <tr>
          <th>{{ $t('dialog.body.openinghours.table.day') }}</th>
          <th>{{ $t('dialog.body.openinghours.table.openinghours') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="day in standardHours" :key="day.dayOfWeek">
      <td>{{ getDayOfWeek(day.dayOfWeek) }}</td>
      <td>
          <span v-if="day.startTime === 'Closed All Day'">
            ❌ {{ $t('dialog.body.openinghours.closedallday') }}
          </span>
          <span v-else>🕒 {{ day.startTime }} - {{ day.endTime }}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'standard-opening-hours',
  props: {
    standardHours: {
      type: Array,
      required: true
    }
  },
  methods: {
    getDayOfWeek(englishWeekday) {
      const days = {
        Monday: this.$t('dialog.body.openinghours.table.monday'),
        Tuesday: this.$t('dialog.body.openinghours.table.tuesday'),
        Wednesday: this.$t('dialog.body.openinghours.table.wednesday'),
        Thursday: this.$t('dialog.body.openinghours.table.thursday'),
        Friday: this.$t('dialog.body.openinghours.table.friday'),
        Saturday: this.$t('dialog.body.openinghours.table.saturday'),
        Sunday: this.$t('dialog.body.openinghours.table.sunday')
      }
      return days[englishWeekday] || englishWeekday // Fallback to English if translation is missing
    }
  }
}
</script>

<style>
.holiday-closure {
  text-align: center;
  padding: 20px;
}

.holiday-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.holiday-table th, .holiday-table td {
  padding: 10px;
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/openinghours/standard-opening-hours.vue